import React from 'react';
import PropTypes from "prop-types";
import { GoogleMapContext } from "../GoogleMap";
import { createLatLng, computeHeading, distanceBetweenPoints, computeOffset, createCircle } from "../../google";
import { createOverlay } from "../../utils/Overlay";

export default class VehicleMarker extends React.Component {
  constructor(props) {
    super(props);
    this.updateTime = Date.now();
    this.fractionalAnimationDistance = 0;
    this.totalAnimationDistance = 0;
    this.totalAnimationDuration = 6000;
    this.currentVehicleHeading = 0;
  }

  static propTypes = {
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
    iconURL: PropTypes.string.isRequired,
  }

  static contextType = GoogleMapContext;

  componentDidMount() {
    const {latitude, longitude, iconURL} = this.props;
    this.marker = createOverlay(iconURL, latitude, longitude, this.context);
    this.updateTime = Date.now();
  }

  // to add a debug circle, if needed
  addCircle(latitude, longitude) {
    if(this.circle) {
      this.circle.setMap(null);
    }
    this.circle = createCircle(latitude, longitude)
    this.circle.setMap(this.context);
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return this.shouldMarkerMove(nextProps.latitude, nextProps.longitude);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    window.cancelAnimationFrame(this.animation);
    const newLatLng = createLatLng(this.props.latitude, this.props.longitude);
    this.updateTime = Date.now();
    this.currentVehicleHeading = computeHeading(this.marker.getCurrentLatLng(), newLatLng);
    if(this.shouldMarkerAnimate(this.props.latitude, this.props.longitude)) {
      this.totalAnimationDistance = distanceBetweenPoints(this.marker.getCurrentLatLng(), newLatLng);
      this.animate();
    }
    else {
      this.jump();
    }
  }

  componentWillUnmount() {
    window.cancelAnimationFrame(this.animation);
    this.marker.removeFromMap();
  }

  shouldMarkerAnimate(latitude, longitude) {
    const oldLatLng = this.marker.getCurrentLatLng();
    const newLatLng = createLatLng(latitude, longitude);
    const distanceBetweenOldAndNewPoints = distanceBetweenPoints(oldLatLng, newLatLng);
    return (distanceBetweenOldAndNewPoints > 1 && distanceBetweenOldAndNewPoints < 2000);
  }

  shouldMarkerMove(latitude, longitude) {
    const oldLatLng = this.marker.getCurrentLatLng();
    const newLatLng = createLatLng(latitude, longitude);
    const distanceBetweenOldAndNewPoints = distanceBetweenPoints(oldLatLng, newLatLng);
    return (distanceBetweenOldAndNewPoints > 1);
  }

  getNewPosition() {
    const animationDuration = Date.now() - this.updateTime;
    const distanceToMove = (this.totalAnimationDistance * animationDuration)/this.totalAnimationDuration;
    const newLatLng = computeOffset(this.marker.getCurrentLatLng(), distanceToMove, this.currentVehicleHeading);
    return newLatLng;
  }

  animate() {
    const newLatLng = this.getNewPosition();
    this.marker.setCoordinates(newLatLng.lat(), newLatLng.lng());
    this.marker.setAngle(this.currentVehicleHeading);
    this.marker.updatePosition();
    this.updateTime = Date.now();
    this.animation = window.requestAnimationFrame(() => {
      if (this.shouldMarkerAnimate(this.props.latitude, this.props.longitude)) {
        this.animate();
      }
    });
  }

  jump() {
    this.marker.setCoordinates(this.props.latitude, this.props.longitude);
    this.marker.setAngle(this.currentVehicleHeading);
    this.marker.updatePosition();
  }

  render() {
    return null;
  }
}
